export default {"src":"/_next/static/media/getOfferIconActive.0129d8f5.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};